export default {
  cancelButton: 'Cancel',
  confirmButton: 'Confirm',
};
